import "./../styles.scss";

import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { notification, Pagination, Spin, Tooltip } from "antd";
import { Checkbox, Menu, Select } from "antd";
import { Delete, EditIcon } from "components/icons";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import InputMask from "react-input-mask";
import Modal from "react-modal";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
// import TdiVerticalDark from "../../../components/icons/TdiVerticalDark";
// import VideoGroup from "../../../components/icons/VideoGroup";
import amplitude from "../../../externals/amplitude";
import {
  addCustomFieldValidationWithDropdown,
  addCustomFieldValidationWithInput,
  addCustomFieldValidationWithMasking,
} from "../../../utils/validations";

const { Option } = Select;

const AddCustomField = (props) => {
  const {
    customData,
    addCustomField,
    loder,
    deleteField,
    updateCustomField,
    settingsRecordsPerPage,
    id: entityId,
    updateCustomFields,
    mastersAdded,
    getCustomField,
    setLoder,
    createCustomFields,
  } = props;
  const [type, setType] = useState();
  const [customId, setCustomId] = useState("");
  const [customloder, setCustomloder] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(20);

  const tableAction = (id) => (
    <Menu
      items={[
        {
          label: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                delOpen(id);
              }}
            >
              <DeleteIcon />
              <span>Delete</span>
            </a>
          ),
          key: "0",
        },
      ]}
    />
  );

  const delOpen = (id) => {
    setCustomId(id);
    setDeleteModalOpen(true);
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [fieldType, setFieldType] = useState("input");
  const [formType, setFormType] = useState("stream");
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [handleType, setHandleType] = useState("");
  const [SelectId, setSelectId] = useState("");
  const [isDisabled, setIsDisabled] = useState("false");
  const [isRequired, setIsRequired] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");

  const openModal = () => {
    setFieldType("input");
    setFormType("stream");
    setIsOpen(true);
    amplitude.logEvent("add_custom_field_clicked");
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const editClose = () => {
    setFieldType(" ");
    setFormType(" ");
    setIsDisabled("false");
    setIsRequired(false);
    setDefaultValue("");
    setEditModalIsOpen(false);
    setInitialState({
      ...initialState,
      formType: "",
      inputFieldName: "",
      selectLabel: "",
      selectoption: " ",
      inputFieldLabel: "",
      inputPlaceholderTitle: "",
      inputMasking: "",
    });
  };

  const deleteCustomField = async () => {
    setCustomloder(true);
    const id = customId;
    await deleteField({ id: id, entityId });
    setCustomloder(false);
    delclose();
    amplitude.logEvent("custom_field_deleted", { id });
  };
  const [initialState, setInitialState] = useState({
    formType: "",
    inputFieldName: "",
    selectLabel: "",
    selectoption: "",
    inputFieldLabel: "",
    inputPlaceholderTitle: "",
    inputMasking: "",
  });
  const editOpen = (data) => {
    setEditModalIsOpen(true);
    setSelectId(data.id);
    setFieldType(data?.fieldType);
    setFormType(data?.formType);
    setIsDisabled(data?.isDisabled === true ? "true" : "false");
    setIsRequired(data?.isRequired || false);
    setDefaultValue(data?.defaultValue || "");
    setInitialState({
      formType: data.formType,
      inputFieldName: data.inputFieldName,
      selectoption: data?.selectoption?.toString(), //select option should be string
      selectLabel: data.selectLabel,
      inputFieldLabel: data.inputFieldLabel,
      inputPlaceholderTitle: data.inputPlaceholderTitle,
      inputMasking: data?.inputMasking || "",
    });
    amplitude.logEvent("edit_custom_field_clicked", { ...data });
  };
  const handleSubmit = async ({
    inputFieldName,
    selectLabel,
    selectoption,
    inputFieldLabel,
    inputPlaceholderTitle,
    inputMasking,
  }) => {
    const field = {
      formType: formType,
      fieldType: fieldType,
      inputFieldName: inputFieldName,
      selectLabel: inputFieldName,
      inputFieldLabel: inputFieldLabel,
      inputPlaceholderTitle: inputPlaceholderTitle,
      selectoption: selectoption !== "" ? selectoption.replace(/,\s*/g, ",").toString().split(",") : [],
      defaultValue: defaultValue,
      isDisabled: isDisabled === "true" ? true : false || false,
      isRequired: isRequired || false,
      inputMasking: inputMasking,
    };
    if (formType === "clip-tagging") {
      if (isDisabled === "true" && isRequired && !defaultValue) {
        // if disabled and required fields are enabled, make default value as mandatory
        notification["warning"]({ message: "Default value is mandatory with disable and required fields!" });
        return;
      }
    }
    setLoder(true);
    const data = await createCustomFields({
      entityId,
      field,
    });
    if (data?.value.success) {
      mastersAdded(data?.value.message);
      setFieldType("");
      setFormType(" ");
      setIsDisabled("false");
      setIsRequired(false);
      setDefaultValue("");
      closeModal();
      getCustomField();
    } else {
      notification["error"]({ message: data?.value.message });
    }
    setLoder(false);
    amplitude.logEvent("custom_field_added", { ...field });
  };

  const handleEditSubmit = async ({
    inputFieldName,
    selectLabel,
    selectoption,
    inputFieldLabel,
    inputPlaceholderTitle,
    inputMasking,
  }) => {
    const field = {
      formType: formType,
      fieldType: fieldType,
      id: SelectId,
      inputFieldName: inputFieldName,
      selectLabel: inputFieldName,
      inputFieldLabel: inputFieldLabel,
      inputPlaceholderTitle: inputPlaceholderTitle,
      defaultValue: defaultValue,
      selectoption: selectoption !== "" ? selectoption.replace(/,\s*/g, ",").toString().split(",") : [],
      isDisabled: isDisabled === "true" ? true : false,
      isRequired: isRequired || false,
      inputMasking: inputMasking,
    };

    if (formType === "clip-tagging") {
      if (isDisabled === "true" && isRequired && !defaultValue) {
        // if disabled and required fields are enabled, make default value as mandatory
        notification["warning"]({ message: "Default value is mandatory with disable and required fields!" });
        return;
      }
    }

    const data = await updateCustomFields({
      data: {
        entityId,
        field,
      },
    });
    if (data?.value.success) {
      mastersAdded(data?.value.message);
      getCustomField();
      editClose();
      setFieldType(" ");
      setFormType(" ");
      setIsDisabled("false");
      setIsRequired(false);
      setDefaultValue("");
    } else {
      notification["error"]({ message: data?.value.message });
    }
    amplitude.logEvent("custom_field_updated", { ...field });
  };

  const handlePageChange = (current) => {
    setActivePage(current);
    setEnd(current * settingsRecordsPerPage);
    setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
  };
  return (
    <>
      <DeleteModal
        deleteComanModel={deleteCustomField}
        loder={customloder}
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        header="Delete"
        content="Are you sure you want to delete?"
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add Custom Field"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="add_customFields" page="organization-profile">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Custom Field</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik
            initialValues={initialState}
            validationSchema={
              fieldType === "input"
                ? addCustomFieldValidationWithInput
                : fieldType === "dropdown"
                  ? addCustomFieldValidationWithDropdown
                  : addCustomFieldValidationWithMasking
            }
            onSubmit={handleSubmit}
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group mb-4">
                      <label className="form-label">Form Type</label>
                      <div className="form-pop-trigger-block">
                        <select
                          name="formType"
                          onChange={(e) => setFormType(e.target.value)}
                          value={formType}
                          className="custom-select form-control"
                          // defaultValue={initialState.fieldType}
                        >
                          <option value="stream">Stream</option>
                          <option value="web-story">Web-story</option>
                          <option value="clip-tagging">Clip-tagging</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group mb-4">
                      <label className="form-label">Field Type</label>
                      <div className="form-pop-trigger-block">
                        <select
                          name="fieldType"
                          onChange={(e) => setFieldType(e.target.value)}
                          value={fieldType}
                          className="custom-select form-control"
                          // defaultValue={initialState.fieldType}
                        >
                          <option value="input">Text Box</option>
                          <option value="select">Dropdown</option>
                          <option value="input-masking">Input Masking</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Enter Field Label <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="inputFieldLabel" type="text" />
                      {touched.inputFieldLabel && errors.inputFieldLabel && (
                        <div className="invalid-feedback">{errors.inputFieldLabel}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Enter Placeholder Title</label>
                      <Field className="form-control" name="inputPlaceholderTitle" type="text" />
                      {touched.inputPlaceholderTitle && errors.inputPlaceholderTitle && (
                        <div className="invalid-feedback">{errors.inputPlaceholderTitle}</div>
                      )}
                    </div>
                    {fieldType === "input" && (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Enter Field Name <span className="required">*</span>
                          </label>
                          <Field
                            // className={touched.inputFieldName && errors.inputFieldName ? "error" : ""}
                            className="form-control"
                            name="inputFieldName"
                            type="text"
                          />
                          {touched.inputFieldName && errors.inputFieldName && (
                            <div className="invalid-feedback">{errors.inputFieldName}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Default Value <span className="required"></span>
                          </label>
                          <Field
                            className="form-control"
                            name="defaultValue"
                            type="text"
                            onChange={(e) => setDefaultValue(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                    {fieldType === "select" && (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Enter Field Name <span className="required">*</span>
                          </label>
                          <Field className="form-control" name="inputFieldName" type="text" />
                          {touched.inputFieldName && errors.inputFieldName && (
                            <div className="invalid-feedback">{errors.inputFieldName}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Add Options <span className="required">*</span>
                          </label>
                          <Field className="form-control" name="selectoption" type="text" />
                          {touched.selectoption && errors.selectoption && (
                            <div className="invalid-feedback">{errors.selectoption}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Default Value <span className="required"></span>
                          </label>
                          <Field
                            className="form-control"
                            name="defaultValue"
                            type="text"
                            onChange={(e) => setDefaultValue(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                    {fieldType === "input-masking" && (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Enter Field Name <span className="required">*</span>
                          </label>
                          <Field
                            // className={touched.inputFieldName && errors.inputFieldName ? "error" : ""}
                            className="form-control"
                            name="inputFieldName"
                            type="text"
                          />
                          {touched.inputFieldName && errors.inputFieldName && (
                            <div className="invalid-feedback">{errors.inputFieldName}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Input Masking Value <span className="required"></span>
                            <Tooltip
                              title={
                                <span>
                                  9 : [0-9]
                                  <br />
                                  a : [A-Za-z]
                                  <br />* : [A-Za-z0-9]
                                </span>
                              }
                            >
                              <InfoCircleOutlined />
                            </Tooltip>
                          </label>
                          <Field className="form-control" name="inputMasking" type="text" />
                          {/* {touched.defaultValue && errors.defaultValue && (
                            <div className="invalid-feedback">{errors.defaultValue}</div>
                          )} */}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Default Value <span className="required"></span>
                          </label>
                          <InputMask
                            className="form-control"
                            name="defaultValue"
                            type="text"
                            defaultValue={defaultValue}
                            mask={values?.inputMasking}
                            onChange={(e) => setDefaultValue(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                    <div className="form-group mb-4">
                      <label className="form-label">Disable Field</label>
                      <div className="form-pop-trigger-block">
                        <select
                          name="isDisabled"
                          onChange={(e) => setIsDisabled(e.target.value)}
                          value={isDisabled}
                          className="custom-select form-control"
                          // defaultValue={initialState.fieldType}
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>
                      </div>
                    </div>
                    {formType === "clip-tagging" ? (
                      <div className="field-items mb-4 d-flex align-items-center">
                        <Checkbox
                          defaultChecked={false}
                          onChange={(e) => {
                            setIsRequired(e.target.checked);
                          }}
                          checked={isRequired}
                          className="me-2"
                        ></Checkbox>
                        <label className="form-label mb-0">Required</label>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <button type="button" className="btn btn-white" onClick={closeModal}>
                    Cancel
                  </button>
                  <Spin spinning={loder} indicator={<LoadingOutlined style={{ fontSize: 25, color: "#fff" }} spin />}>
                    <button className="btn btn-primary fill" type="submit">
                      Add
                    </button>
                  </Spin>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      <Modal
        isOpen={editModalIsOpen}
        onRequestClose={editClose}
        shouldCloseOnOverlayClick={false}
        contentLabel="Edit Custom Field"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Custom Field</h5>
            <button type="button" onClick={editClose} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik
            initialValues={initialState}
            validationSchema={
              fieldType === "input"
                ? addCustomFieldValidationWithInput
                : fieldType === "dropdown"
                  ? addCustomFieldValidationWithDropdown
                  : addCustomFieldValidationWithMasking
            }
            onSubmit={handleEditSubmit}
          >
            {({ errors, touched, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group mb-4">
                      <label className="form-label">Form Type</label>
                      <div className="form-pop-trigger-block">
                        <select
                          className="custom-select form-control"
                          name="formType"
                          onChange={(e) => setFormType(e.target.value)}
                          // component={Select}
                          value={formType}
                          // dropdownStyle={{ zIndex: 99999999 }}
                          defaultValue={initialState.formType}
                        >
                          <option value="stream">Stream</option>
                          <option value="Web-story">Web-story</option>
                          <option value="clip-tagging">Clip-tagging</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group mb-4">
                      <label className="form-label">Field Type</label>
                      <div className="form-pop-trigger-block">
                        <select
                          className="custom-select form-control"
                          name="fieldType"
                          onChange={(e) => setFieldType(e.target.value)}
                          // component={Select}
                          value={fieldType}
                          // dropdownStyle={{ zIndex: 99999999 }}
                          defaultValue={initialState.fieldType}
                        >
                          <option value="input">Text Box</option>
                          <option value="select">Dropdown</option>
                          <option value="input-masking">Input Masking</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Enter Field Label <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="inputFieldLabel"
                        type="text"
                        defaultValue={initialState.inputFieldLabel}
                      />
                      {touched.inputFieldLabel && errors.inputFieldLabel && (
                        <div className="invalid-feedback">{errors.inputFieldLabel}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Enter Placeholder Title</label>
                      <Field
                        className="form-control"
                        name="inputPlaceholderTitle"
                        type="text"
                        defaultValue={initialState.inputPlaceholderTitle}
                      />
                      {touched.inputPlaceholderTitle && errors.inputPlaceholderTitle && (
                        <div className="invalid-feedback">{errors.inputPlaceholderTitle}</div>
                      )}
                    </div>
                    {fieldType === "input" && (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Field Name <span className="required">*</span>
                          </label>
                          <Field className="form-control" name="inputFieldName" type="text" />
                          {touched.inputFieldName && errors.inputFieldName && (
                            <div className="invalid-feedback">{errors.inputFieldName}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Default Value <span className="required"></span>
                          </label>
                          <Field
                            className="form-control"
                            name="defaultValue"
                            type="text"
                            defaultValue={defaultValue}
                            onChange={(e) => setDefaultValue(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                    {fieldType === "select" && (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Field Name <span className="required">*</span>
                          </label>
                          <Field className="form-control" name="inputFieldName" type="text" />
                          {touched.inputFieldName && errors.inputFieldName && (
                            <div className="invalid-feedback">{errors.inputFieldName}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Add Options <span className="required">*</span>
                          </label>
                          <Field className="form-control" name="selectoption" type="text" />
                          {touched.selectoption && errors.selectoption && (
                            <div className="invalid-feedback">{errors.selectoption}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Default Value <span className="required"></span>
                          </label>
                          <Field
                            className="form-control"
                            name="defaultValue"
                            type="text"
                            defaultValue={defaultValue}
                            onChange={(e) => setDefaultValue(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                    {fieldType === "input-masking" && (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Enter Field Name <span className="required">*</span>
                          </label>
                          <Field
                            // className={touched.inputFieldName && errors.inputFieldName ? "error" : ""}
                            className="form-control"
                            name="inputFieldName"
                            type="text"
                          />
                          {touched.inputFieldName && errors.inputFieldName && (
                            <div className="invalid-feedback">{errors.inputFieldName}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Input Masking Value <span className="required"></span>
                            <Tooltip
                              title={
                                <span>
                                  9 : [0-9]
                                  <br />
                                  a : [A-Za-z]
                                  <br />* : [A-Za-z0-9]
                                </span>
                              }
                            >
                              <InfoCircleOutlined />
                            </Tooltip>
                          </label>
                          <Field className="form-control" name="inputMasking" type="text" />
                          {/* {touched.defaultValue && errors.defaultValue && (
                            <div className="invalid-feedback">{errors.defaultValue}</div>
                          )} */}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Default Value <span className="required"></span>
                          </label>
                          <InputMask
                            className="form-control"
                            name="defaultValue"
                            type="text"
                            defaultValue={defaultValue}
                            onChange={(e) => setDefaultValue(e.target.value)}
                            mask={initialState?.inputMasking}
                          />
                        </div>
                      </>
                    )}
                    <div className="form-group mb-4">
                      <label className="form-label">Disable Field</label>
                      <div className="form-pop-trigger-block">
                        <select
                          name="isDisabled"
                          onChange={(e) => setIsDisabled(e.target.value)}
                          value={isDisabled}
                          className="custom-select form-control"
                          // defaultValue={initialState.fieldType}
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>
                      </div>
                    </div>
                    {formType === "clip-tagging" ? (
                      <div className="field-items mb-4 d-flex align-items-center">
                        <Checkbox
                          defaultChecked={false}
                          onChange={(e) => {
                            setIsRequired(e.target.checked);
                          }}
                          checked={isRequired}
                          className="me-2"
                        ></Checkbox>
                        <label className="form-label mb-0">Required</label>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={editClose}>
                        Cancel
                      </button>
                      <button className="btn btn-primary" type="submit">
                        Save
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 25, color: "#000", marginLeft: 30 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Custom Fields</h4>
            <p>Entertainment, Sports, News</p>
          </div>
          <AccessControl code="add_customFields" page="organization-profile">
            <div className="right-btn-block">
              <div class="button-container">
                {/* <button class="btn-s-one me-3">
                <UploadIconBlue className="me-2" /> Upload a CSV file{" "}
              </button> */}
                <button class="btn btn-primary" onClick={openModal}>
                  Add Custom Field
                </button>
              </div>
            </div>
          </AccessControl>
        </div>
        <div className="configuration-items-row mt-5 row">
          <div className="col-md-12">
            <h5 className="title-small">Added Custom Fields</h5>
          </div>
          {customData?.slice(start, end)?.map((data) => {
            if (data?.fieldType === "input" || data?.fieldType === "input-masking") {
              return (
                <>
                  <div className="col-md-2">
                    <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                      {/* <AccessControl code="delete_customFields" page="configuration">
                        <Dropdown
                          className=""
                          overlay={tableAction(data.id)}
                          trigger={["click"]}
                          overlayClassName={"tableActionBlock"}
                          placement={"bottomRight"}
                        >
                          <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                            <TdiVerticalDark />
                          </a>
                        </Dropdown>
                      </AccessControl> */}
                      {/* <div className="icon-block">
                        <VideoGroup />
                      </div> */}
                      <div className="confi-block-col">
                        <h4>Field Type - {data?.fieldType === "input" ? "Text Box" : "Input Masking"}</h4>
                        <h4>Form Type - {data?.formType}</h4>
                        <h4 className="word-break-two title_Pascal">Field Name - {data?.inputFieldName}</h4>
                      </div>
                      {/* <div className="btn-action">
                        <button className="btn btn-edit btn-primary" onClick={() => editOpen(data)}>
                          Edit
                        </button>
                      </div> */}
                      <div className="action-buttons gap-3">
                        <AccessControl code="edit_customFields" page="organization-profile">
                          <button>
                            <EditIcon
                              onClick={() => {
                                editOpen(data);
                              }}
                            />
                          </button>
                        </AccessControl>
                        <AccessControl code="delete_customFields" page="organization-profile">
                          <button>
                            <Delete
                              onClick={() => {
                                delOpen(data?.id);
                              }}
                            />
                          </button>
                        </AccessControl>
                      </div>
                    </div>
                  </div>
                </>
              );
            }
            if (data?.fieldType === "select") {
              return (
                <>
                  <div className="col-md-2">
                    <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                      {/* <Dropdown
                        className=""
                        overlay={tableAction(data.id)}
                        trigger={["click"]}
                        overlayClassName={"tableActionBlock"}
                        placement={"bottomRight"}
                      >
                        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                          <TdiVerticalDark />
                        </a>
                      </Dropdown> */}
                      {/* <div className="icon-block">
                        <VideoGroup />
                      </div> */}
                      <div className="confi-block-col">
                        <h4>Field Type - {"Dropdown"}</h4>
                        <h4>Form Type - {data?.formType}</h4>
                        <h4 className="word-break-two title_Pascal">Field Name - {data?.inputFieldName}</h4>
                      </div>
                      <div className="action-buttons gap-3">
                        <AccessControl code="edit_customFields" page="organization-profile">
                          <button>
                            <EditIcon onClick={() => editOpen(data)} />
                          </button>
                        </AccessControl>
                        <AccessControl code="delete_customFields" page="organization-profile">
                          <button>
                            <Delete
                              onClick={() => {
                                delOpen(data?.id);
                              }}
                            />
                          </button>
                        </AccessControl>
                      </div>
                      {/* <div className="btn-action">
                        <button className="btn btn-edit btn-primary" onClick={() => editOpen(data)}>
                          Edit
                        </button>
                      </div> */}
                    </div>
                  </div>
                </>
              );
            }
          })}
        </div>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={customData?.length}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};
export default AddCustomField;
